import Vue from 'vue';
import App from './App';
import router from './router';

import store from './store/store';

import CryptoJS from "crypto-js";

let keySize = 256;
let iterations = 100;

const encrypt = function (msg, pass) {
  var salt = CryptoJS.lib.WordArray.random(128 / 8);
  var key = CryptoJS.PBKDF2(pass, salt, {
    keySize: keySize / 32,
    iterations
  });
  var iv = CryptoJS.lib.WordArray.random(128 / 8);
  var encrypted = CryptoJS.AES.encrypt(msg, key, {
    iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC
  });
  var transitmessage = salt.toString() + iv.toString() + encrypted.toString();
  return transitmessage;
};

import debounce from 'lodash/debounce';

const writeStore = debounce(function (state, key) {
  let toEncrypt = JSON.stringify({
    auth: state.auth,
    settings: state.settings,
    authenticators: state.authenticators,
    secretTemplates: state.secretTemplates,
  });
  localStorage.setItem('store', encrypt(toEncrypt, key));
}, 200, {maxWait: 1000});

store.subscribe((mutation, state) => {
  if (store.getters['auth/loggedin'] && store.getters['settings/okey']) {
    let okey = store.getters['settings/okey'];
    if (okey) {
      writeStore(state, okey);
    }
  }
});

import axios from 'axios';
import {onSuccess, onError, beforeRequestSuccess, beforeRequestError} from './interceptors/Jwt';

import 'bootstrap/dist/css/bootstrap.css';
import '../build/css/mdb.css';
import "vue-material-design-icons/styles.css";
import 'toastr/build/toastr.css';

axios.interceptors.request.use(beforeRequestSuccess, beforeRequestError);
axios.interceptors.response.use(onSuccess, onError);

// Vue.config.productionTip = false;
// Vue.config.devtools = true;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js